import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limitParam: number, opt: string) : string {
    let limit = limitParam ? limitParam : 10;
    let trail = opt ? opt : '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}


// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/truncate.pipe.ts